// src/api/axiosInstance.ts
// src/api/axiosInstance.ts
import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL!;

const axiosInstance = axios.create({
  baseURL: `${baseUrl}/api`,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt');
  if (token) {
    config.headers.Authorization = `${token}`;
  }
  return config;
});

export default axiosInstance;

